module.exports = __webpack_public_path__ + "img/btpn.e52fdfff.svg";